import { render, staticRenderFns } from "./RsaScalaTinettiViewComponent.vue?vue&type=template&id=ca55d2c6"
import script from "./RsaScalaTinettiViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaScalaTinettiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports